module.exports = __webpack_public_path__ + "img/gpu_cover_sol.25cb0631.png";